declare global {
    interface Window {
        // eslint-disable-next-line no-unused-vars
        gtag?: (...args: any[]) => void;
    }
}

export const normaliseGAEventName = (name: string): string => {
    // Convert camelCase to space-separated
    const spaced = name.replace(/([a-z])([A-Z])/g, "$1 $2");

    // Remove punctuation (keep letters, numbers, spaces, underscores)
    const cleaned = spaced.replace(/[^a-zA-Z0-9\s_]/g, "");

    // Convert to lowercase, split into words, take first 6, join with underscores
    return cleaned
        .toLowerCase()
        .split(/[\s_]+/)
        .slice(0, 6)
        .join("_");
};

export const logGoogleAnalyticsEvent = (eventName: string, eventParams?: Record<string, any>) => {
    const normalisedEventName = normaliseGAEventName(eventName);

    if (typeof window !== "undefined" && window.gtag) {
        window.gtag("event", normalisedEventName, eventParams || {});
    } else {
        console.warn("⚠️ gtag not initialized");
    }
};
